import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import SyncIcon from '@material-ui/icons/Sync';
import CircularProgress from '@material-ui/core/CircularProgress';
import UsersTable from '../../components/UsersTable';
import * as actions from '../../actions/users';

const useStyles = makeStyles(theme => ({
  loading: {
    marginTop: theme.spacing(10),
    position: 'fixed',
    left: '50%',
  },
  fab: {
    width: '60px',
    height: '60px',
    bottom: '15px',
    left: '25px',
    marginTop: theme.spacing(2),
  },
  fabColumn: {
    width: '100px',
  },
}));

export const Users = props => {
  // eslint-disable-next-line no-shadow
  const { data, isLoading, selectUser, addUser, getUsers, syncInit, syncInProgress } = props;

  useEffect(() => {
    getUsers();
    // eslint-disable-next-line import/no-extraneous-dependencies
  }, [getUsers]);

  const classes = useStyles();
  return (
    <>
      <Grid container spacing={0} wrap="nowrap">
        <Grid item xs={12}>
          {isLoading ? <CircularProgress className={classes.loading} /> : null}
          <UsersTable data={data} onRowClick={selectUser} />
        </Grid>

        <Grid item className={classes.fabColumn}>
          <div>
            <Fab
              color="primary"
              aria-label="create new user"
              className={classes.fab}
              aria-haspopup="true"
              onClick={addUser}
            >
              <AddIcon />
            </Fab>
            <Fab
              color="secondary"
              aria-label="sync users list"
              className={classes.fab}
              aria-haspopup="true"
              onClick={syncInit}
              disabled={syncInProgress}
            >
              <SyncIcon />
            </Fab>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

Users.defaultProps = {
  getUsers: () => {},
  data: [],
  isLoading: false,
  syncInProgress: false,
  selectUser: () => {},
  addUser: () => {},
  syncInit: () => {},
};

Users.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      email: PropTypes.string,
      id: PropTypes.number,
    })
  ),
  isLoading: PropTypes.bool,
  syncInProgress: PropTypes.bool,
  selectUser: PropTypes.func,
  addUser: PropTypes.func,
  getUsers: PropTypes.func,
  syncInit: PropTypes.func,
};

const mapStateToProps = state => {
  const { users } = state;
  return {
    data: users.users,
    isLoading: users.isLoading,
    syncInProgress: users.initSyncInProgress,
  };
};

const mapDispatchToProps = {
  selectUser: actions.selectUser,
  addUser: actions.addUser,
  getUsers: actions.getUsers,
  syncInit: actions.syncInit,
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
